import React from "react";
import PropTypes from "prop-types";

//Import WebCam
import Webcam from "react-webcam";
import "./webcam.css";

function WebcamCap(props) {
  const [deviceId, setDeviceId] = React.useState({});
  const [devices, setDevices] = React.useState([]);
  const [activeIndex, setActiveIndex] = React.useState(0);

  const handleDevices = React.useCallback(
    (mediaDevices) =>
      setDevices(mediaDevices.filter(({ kind }) => kind === "videoinput")),
    [setDevices]
  );

  React.useEffect(() => {
    navigator.mediaDevices.enumerateDevices().then(handleDevices);
  }, [handleDevices]);

  const webcamRef = React.useRef(null);

  const capture = React.useCallback(async () => {
    const imageSrc = webcamRef.current.getScreenshot();
    console.log(imageSrc);
    const blob = await fetch(imageSrc).then((res) => res.blob());
    props.urlImage(blob);
  }, [webcamRef]);

  return (
    <>
      <div>
        {devices.map((device, key) => {
          return (
            <button
              className={
                activeIndex == key
                  ? "btn btn-success btn-sm"
                  : "btn btn-light btn-sm"
              }
              key={device.deviceId}
              onClick={() => {
                setDeviceId(device);
                setActiveIndex(key);
              }}
            >
              {`Camera ${key + 1}`}
            </button>
          );
        })}
        <br />
        <Webcam
          audio={false}
          height={200}
          ref={webcamRef}
          screenshotFormat="image/jpeg"
          width={200}
          videoConstraints={deviceId}
        />
        <br />
        <i
          className="bi bi-camera"
          onClick={capture}
          style={{ padding: ".375rem .75rem", fontSize: "3rem" }}
        ></i>
      </div>
    </>
  );

  // const videoConstraints = {
  //   width: 200,
  //   height: 200,
  //   facingMode: { exact: "environment" },
  // };

  // const webcamRef = React.useRef(null);

  // const capture = React.useCallback(async () => {
  //   const imageSrc = webcamRef.current.getScreenshot();
  //   console.log(imageSrc);
  //   const blob = await fetch(imageSrc).then((res) => res.blob());
  //   props.urlImage(blob);
  // }, [webcamRef]);

  // return (
  //   <>
  //     <div>
  //       <Webcam
  //         audio={false}
  //         height={200}
  //         ref={webcamRef}
  //         screenshotFormat="image/jpeg"
  //         width={200}
  //         videoConstraints={videoConstraints}
  //       />
  //       <br />
  //       <i
  //         className="bi bi-camera"
  //         onClick={capture}
  //         style={{ padding: ".375rem .75rem", fontSize: "3rem" }}
  //       ></i>
  //     </div>
  //   </>
  // );
}

export default WebcamCap;

WebcamCap.propTypes = {
  urlImage: PropTypes.func,
  //   hidden: PropTypes.bool,
};
